<div style="display: inline;" >
    <button  mat-raised-button (click)="open()"  [style.color]="data.categoryColor" class="btncss"  [style.fontSize]="data.categoryFontSize" >{{menuData.categoryName | characterPipe}}
    </button>
</div>
